import axios from "axios";
import moment from 'moment';

class Sap {
  constructor() {
      this.Sap = axios.create({
      baseURL: process.env.REACT_APP_PUBLIC_DOMAIN_3,
      withCredentials: true,
    });
  }
  
  read = (year) => {
    console.log('Read sap Service')
    return this.Sap
    .get(`readppto/${year}`)
    .then(({data}) => data)
    // .then(({data}) => console.log(data))
  }
  // readmongo = (event) => {
  //   const e = moment(event).format('YYYY-MM-DD')
  //   console.log('Reading ppto from mongo, date: ' + e)
  //   return this.Sap
  //   .get(`readppto/day/${e}`)
  //   .then(({data}) => data)
  //   // .then(({data}) => console.log(data))
  // }
}

const sapService = new Sap();

export default sapService;